import ApiConfig from "../config/APICongig";
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./Auth";
import { sections } from "../layouts/DashboardLayout/NavBar/SidebarTabs";

export const UserContext = createContext();

export default function AuthProvider(props) {
  const auth = useContext(AuthContext);
  const [applicationData, setApplicationData] = useState({});
  const [loader, setLoader] = useState(false);
  const [contextReady, setContextReady] = useState(false);
  const [achievementData, setAchievementData] = useState(null);
  const [profile, setProfile] = useState({});
  const [Notifications, setNotifications] = useState([]);
  const [appSetting, setAppSetting] = useState({});
  const [usersModules, setUsersModules] = useState([]);
  const [imagesUrls, setImageUrls] = useState({});
  const userData = async () => {
    setLoader(true);
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: `${ApiConfig.applicationData}`,
      });
      if (res.status === 200) {
        setApplicationData(res.data);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const userprofile = async () => {
    setLoader(true);
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: `${ApiConfig.getUserProfile}`,
      });
      if (res.status === 200) {
        setProfile(res.data?.data);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const userModules = async () => {
    setLoader(true);
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: `${ApiConfig.getFreeModules}`,
      });
      if (res.status === 200) {
        setUsersModules(res.data?.data[0]?.modules);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const getImageUrl = async () => {
    setLoader(true);
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: `${ApiConfig.getImageUrl}`,
      });
      if (res.status === 200) {
        setImageUrls(res.data?.data[0]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getAchievement = async () => {
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: ApiConfig.getAchievement,
      });
      if (res.status === 200) {
        setAchievementData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getAllNotifications = async () => {
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: ApiConfig.getAllNotifications,
      });
      if (res.status === 200) {
        setNotifications(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAppSettings = async () => {
    try {
      const res = await axios({
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        url: ApiConfig.getAppSetting,
      });
      if (res.status === 200) {
        setAppSetting(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const protectedRoute = () => {
    const currentPath = window.location.pathname;
    const section = sections[0];

    if (!profile?.upgradeFreePlan) {
      for (const route of section?.items) {
        if (route.href === currentPath && route.access) {
          return true;
        }

        // Check subRoutes if they exist
        if (route.subRoutes && Array.isArray(route.subRoutes)) {
          for (const subRoute of route.subRoutes) {
            if (subRoute.href === currentPath && subRoute.access) {
              return true;
            }
          }
        }
      }
    } else {
      // Check main routes
      for (const route of usersModules) {
        if (route.href === currentPath && route.access) {
          return true;
        }

        // Check subRoutes if they exist
        if (route.subRoutes && Array.isArray(route.subRoutes)) {
          for (const subRoute of route.subRoutes) {
            if (subRoute.href === currentPath && subRoute.access) {
              return true;
            }
          }
        }
      }
    }

    // If no match is found, return false
    return false;
  };

  useEffect(() => {
    getImageUrl();
  }, []);
  useEffect(() => {
    if (auth.userLoggedIn) {
      setContextReady(false);
      Promise.allSettled([
        userData(),
        getAchievement(),
        getAllNotifications(),
        userprofile(),
        getAppSettings(),
        userModules(),
      ]).finally(() => {
        setContextReady(true);
      });
    } else {
      setContextReady(false);
    }
  }, [auth.userLoggedIn, localStorage.getItem("token")]);
  let data = {
    applicationData: applicationData,
    loading: loader,
    achievementData: achievementData,
    userData: () => userData(),
    getAchievement: () => getAchievement(),
    getAllNotifications: () => getAllNotifications(),
    userprofile: () => userprofile(),
    userModules: () => userModules(),
    protectedRoute: () => protectedRoute(),
    Notifications: Notifications,
    profile: profile,
    appSetting: appSetting,
    usersModules: usersModules,
    imagesUrls: imagesUrls,
    contextReady: contextReady,
  };

  return (
    <UserContext.Provider value={data}>{props.children}</UserContext.Provider>
  );
}
